import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'acl-installation-no-access',
  standalone: false,
  templateUrl: './installation-no-access.component.html',
  styleUrl: './installation-no-access.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationNoAccessComponent {
  readonly router = inject(Router);

  readonly installationId = input.required<number>();

  toLicense(): void {
    this.router.navigate([
      'installation/' + this.installationId() + '/license',
    ]);
  }
}
